<script lang="ts">
  import type { FunctionalComponent, HTMLAttributes } from 'vue'
  export interface DataListItemIconProps {
    class?: HTMLAttributes['class']
    icon?: FunctionalComponent
  }
</script>

<script setup lang="ts">
  import { cn } from '@gat-ship/vue-components'
  import { useDataListItem } from './DataListItem.vue'
  const props = defineProps<DataListItemIconProps>()
  const { variant } = useDataListItem()
</script>

<template>
  <div
    :class="
      cn(
        'flex size-10 shrink-0 items-center justify-center rounded border transition-all duration-300 group-hover:scale-110',
        {
          'bg-background group-hover:bg-background-lighter':
            variant === 'secondary'
        },
        props.class
      )
    "
  >
    <slot>
      <component :is="props.icon" class="size-5" />
    </slot>
  </div>
</template>
